<template>
  <div class="receiver-select">
    <h3 class="blue-title">
      {{ info.teamName }}
      <span class="blue-title__right">签发人:{{ info.signer }}</span>
    </h3>
    <p class="receiver-desc">{{ info.teamDesc }}</p>
    <el-row>
      <h4 class="accept-header">
        <b>*</b>请先选择接收人员
      </h4>
      <el-row>
        <el-radio v-for="item in personList" :key="item.accountId" :label="item.accountId"
          v-model="selected">{{ item.name }}</el-radio>
      </el-row>
    </el-row>
    <el-row type="flex" justify="space-around">
      <el-button type="primary" :loading="flag" @click="submitHandler">上报</el-button>
      <el-button type="danger" @click="cancelHandler">取消</el-button>
    </el-row>
  </div>
</template>
<script>
import ReceiverApi from "@/api/dict/ReceiverManageApi.js";
import SetupApi from "../../../api/setup/index.js";
export default {
  name: "receiverSelect",
  props: {
    info: {
      type: Object
    }
  },
  data() {
    return {
      selected: "",
      personList: [],
      flag: false
    };
  },
  methods: {
    submitHandler() {
      if (!this.selected) {
        this.$message({
          type: "error",
          message: "请选择接收人员"
        });
      } else {
        if (this.flag) {
          return
        }
        this.flag = true
        let Api = new SetupApi();
        Api.reportItem({
          itemInfoId: this.info.itemInfoId,
          transActors: this.selected
        }).then(res => {
          this.flag = false
          if (res.code === 1) {
            this.$emit("success");
          }
        }).catch(_ => {
          this.flag = false
        })
      }
    },
    cancelHandler() {
      this.selected = "";
      this.$emit("close");
    }
  },
  mounted() {
    let Api = new ReceiverApi();
    Api.listPage({ name: "", status: 1 }).then(res => {
      this.personList = res.data.records;
    });
  }
};
</script>
<style lang="scss" scoped>
.receiver-select {
  .blue-title {
    height: 50px;
    padding: 0 15px;
    background: linear-gradient(0deg, #8bc8f0, #b1dcfc);
    border-radius: 4px 4px 0px 0px;
    font-size: 21px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #043e63;

    .blue-title__right {
      color: orangered;
      float: right;
      font-size: 14px;
    }
  }

  .receiver-desc {
    line-height: 1.2;
    font-size: 16px;
    border: 1px solid #043e63;
    border-radius: 14px;
    margin: 10px 0;
    padding: 10px;
  }

  .accept-header {
    height: 30px;
    line-height: 30px;
    color: #043e63;

    b {
      color: red;
    }
  }
}
</style>
